import { render } from "./yc-index.vue?vue&type=template&id=9fcf36e6&scoped=true"
import script from "./yc-index.vue?vue&type=script&lang=js"
export * from "./yc-index.vue?vue&type=script&lang=js"

import "./yc-index.vue?vue&type=style&index=0&id=9fcf36e6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fcf36e6"]])

export default __exports__